import PropTypes from 'prop-types';

export default {
  assets: PropTypes.array,
};
